/**
 * useQuiz — subscribe no adapter pra quizState do questionId dado.
 *
 * Re-renderiza a cada atualização (master abre, aluno responde, master fecha).
 */

import { useEffect, useState } from 'react'

import { useAdapter } from '../adapter'
import type { QuizStateSnapshot } from '../types/adapter'

export function useQuiz(questionId: string | null): QuizStateSnapshot | null {
  const adapter = useAdapter()
  const [state, setState] = useState<QuizStateSnapshot | null>(
    questionId ? adapter.getQuizState(questionId) : null,
  )

  useEffect(() => {
    if (!questionId) {
      setState(null)
      return
    }

    // Snapshot inicial caso mude de questionId
    setState(adapter.getQuizState(questionId))

    const off = adapter.on('quizState', (payload: QuizStateSnapshot) => {
      if (payload.questionId !== questionId) return
      setState(payload)
    })
    // sessionSnapshot tb traz quizzes
    const offSnap = adapter.on('sessionSnapshot', () => {
      setState(adapter.getQuizState(questionId))
    })

    return () => {
      off()
      offSnap()
    }
  }, [adapter, questionId])

  return state
}
